import { useRef } from "react";

type Callback = (...args: any[]) => any;

type MemoizationCallbacks<CB> = {
	refreshedCallback: CB;
	persistedCallback: CB | undefined;
};

export const useRenderPhaseCallback = <CB extends Callback = any>(callback: CB): CB => {
	const memoizationRef = useRef<MemoizationCallbacks<CB>>({
		refreshedCallback: callback,
		persistedCallback: undefined,
	});
	/** Always refresh the callback passed to the hook. */
	memoizationRef.current.refreshedCallback = callback;

	/** Create a persisted callback to any usage outside. */
	if (!memoizationRef.current.persistedCallback) {
		memoizationRef.current.persistedCallback = ((...args: Parameters<CB>) =>
			memoizationRef.current.refreshedCallback(...args)) as CB;
	}

	return memoizationRef.current.persistedCallback as CB;
};
